<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.96708 28.1409C19.7998 26.4031 25.4193 41.1739 26.5 48.7765C25.4193 50.947 21.0966 54.2019 12.4512 49.8575L13.5318 48.7714C10.65 47.6854 6.18322 44.8615 11.3705 42.2549C8.48867 40.4448 3.80572 36.6073 8.12844 35.7384C5.96708 33.5696 2.5089 29.0138 5.96708 28.1409Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M59.0329 28.1409C45.2002 26.4031 39.5807 41.1739 38.5 48.7765C39.5807 50.947 43.9034 54.2019 52.5488 49.8575L51.4682 48.7714C54.35 47.6854 58.8168 44.8615 53.6295 42.2549C56.5113 40.4448 61.1943 36.6073 56.8716 35.7384C59.0329 33.5696 62.4911 29.0138 59.0329 28.1409Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.5 24V10H36.5M42.5 24V30C40.1667 30.3333 35.5 31.8 35.5 35C36.1667 37.3333 37.5 42.4 37.5 44C37.5 46 36.5 53 32.5 54C29.5 53 27.5 46 27.5 44C28.1667 42 29.5 37.4 29.5 35C29.5 32.6 24.8333 30.6667 22.5 30V24M42.5 24H22.5M22.5 24V10H28.5M28.5 10V18M28.5 10H36.5M36.5 10V14"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
